// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2R7ee","info":"UpdateTermsInfo_info__50K2t"};